export const ColorHelper = {
    colors: {
        regular: '#20c997',
        break: '#0dcaf0',
    },
    violationColors: {
        WorkOnSundayOrHoliday: '#fd7e14',
        WorkDuringNightTime: '#fd7e14',
        WorkDayLongerThan10H: '#fd7e14',
        DailyRestTimeTooShort: '#fd7e14',
        BreakIsTooShort: '#adb5bd',
        BreakNotInValidTimeFrame: '#dc3545',
        TotalBreakTimeNotEnough: '#dc3545',
        BreakNotInValidTimeFrameButAlreadyValidPause:'#adb5bd'
    },
    getViolationColor(type) {
        return this.violationColors[type] || '#FF0000';
    },
    getColor(type) {
        return this.colors[type] || '#000000';
    },
    setTransparentColor(color, alpha) {
        const rgbColor = this.hexToRgb(color);
        return `rgba(${rgbColor.r}, ${rgbColor.g}, ${rgbColor.b}, ${alpha})`;
    },
    lightenColor(hexColor, percentage) {
        hexColor = hexColor.replace('#', '');

        const r = parseInt(hexColor.substring(0, 2), 16);
        const g = parseInt(hexColor.substring(2, 4), 16);
        const b = parseInt(hexColor.substring(4, 6), 16);

        const newR = Math.min(255, r + Math.round(percentage / 100 * (255 - r)));
        const newG = Math.min(255, g + Math.round(percentage / 100 * (255 - g)));
        const newB = Math.min(255, b + Math.round(percentage / 100 * (255 - b)));

        const lightenedHex = `#${newR.toString(16).padStart(2, '0')}${newG.toString(16).padStart(2, '0')}${newB.toString(16).padStart(2, '0')}`;

        return lightenedHex;
    },
    hexToRgb(hex) {
        const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    },
};